/**
 * Shared filter mapping constants
 * Centralizes the column-to-API filter key mappings used across the application
 */

export interface FilterMapping {
  apiKey: string;
  filterGroup: string;
}

export type FilterMapConfig = Record<string, FilterMapping>;

/**
 * Standard filter map configuration
 * Maps column IDs to their corresponding API keys and filter groups
 */
export const COLUMN_FILTER_MAP: FilterMapConfig = {
  status: { apiKey: 'invoiceStatusSet', filterGroup: 'filters' },
  invoiceNumber: { apiKey: 'invoiceNumber', filterGroup: 'filters' },
  aggregateShipmentType: { apiKey: 'shipmentType', filterGroup: 'shipmentFilters' },
  shipmentNumber: { apiKey: 'shipmentNumber', filterGroup: 'shipmentFilters' },
  tradeLane: { apiKey: 'tradeLane', filterGroup: 'tradeLaneFilters' },
  service: { apiKey: 'service', filterGroup: 'shipmentFilters' },
  incoterm: { apiKey: 'incoterm', filterGroup: 'shipmentFilters' },
  billedEntity: { apiKey: 'billedEntity', filterGroup: 'filters' },
  shipper: { apiKey: 'shipper', filterGroup: 'shipmentFilters' },
  consignee: { apiKey: 'consignee', filterGroup: 'shipmentFilters' },
  date: { apiKey: 'date', filterGroup: 'dateFilters' },
};

/**
 * Get filter mapping for a given column ID
 */
export const getFilterMapping = (columnId: string): FilterMapping | undefined => COLUMN_FILTER_MAP[columnId];
